import React, { useEffect, useState } from "react";

interface DateDisplayProps {
  className?: string;
}

const DateDisplay: React.FC<DateDisplayProps> = ({ className }) => {
  const [localDate, setLocalDate] = useState<string>("");

  useEffect(() => {
    const date = new Date();
    const options: Intl.DateTimeFormatOptions = {
      weekday: "long",
      month: "long",
      day: "numeric",
    };
    const formattedDate = date.toLocaleDateString("fr-CA", options);
    const capitalizedDate =
      formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
    setLocalDate(capitalizedDate);
  }, []);

  return (
    <h2 className={`text-lg sm:text-xl ${className || ""}`}>
      Nous sommes le {localDate}
    </h2>
  );
};

export default DateDisplay;
